import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';

import TextInput from '../shared/components/forms/TextInput';

const InputsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const UsernameInputToggler = ({ username, handleChange, valid }) => (
  <InputsWrapper>
    <TextInput
      name="username"
      type="text"
      value={username}
      placeholder="Adres email"
      onChange={handleChange}
      isRequired
      valid={valid}
      invalidText="Podany adres e-mail jest nieprawidłowy."
      autofocus
    />
  </InputsWrapper>
);

UsernameInputToggler.propTypes = {
  handleChange: PropTypes.func.isRequired,
  username: PropTypes.string,
  valid: PropTypes.bool,
};

UsernameInputToggler.defaultProps = {
  username: '',
  valid: true,
};

export default UsernameInputToggler;
